module.exports = __webpack_public_path__ + "img/guide-service.6d2489a3.png";